
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-50e7635a&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Start.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Start.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-50e7635a!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Start.vue"),
  /* scopeId */
  "data-v-50e7635a",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/start/Start.vue
// module id = 79
// module chunks = 1